import { ThemeProvider } from '@creditas-ui/react';
import { standard } from '@creditas-ui/themes';
import { Provider } from 'react-redux';

import type { AppCustomProps } from '.';
import { Routes } from './Routes';
import { Feedback } from './components/base-components/feedback/Feedback';
import { AppContextProvider, CustomPropsProvider } from './contexts';
import { setupStore } from './store';

export const App: React.FC<AppCustomProps> = (props) => {
  return (
    <CustomPropsProvider {...props}>
      <Provider store={setupStore()}>
        <AppContextProvider>
          <ThemeProvider theme={standard}>
            <Feedback />
            <Routes />
          </ThemeProvider>
        </AppContextProvider>
      </Provider>
    </CustomPropsProvider>
  );
};
